import React from 'react';
import {
    Nav,
    HeartFilled,
    DownloadCircleFilled,
    FolderFilled,
    useBreakpoint,
    Tooltip,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { RoutePaths } from 'types/enums';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { getIsCurrentPath } from 'helpers';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import { HiddenByCss } from 'components/CommonUi/Hidden';
import { useGetBasename } from 'hooks/useGetBasename/useGetBasename';

export const usePrivateNavigation = () => {
    const { isAuthenticated } = useAuthentication();
    const basename = useGetBasename();
    const isMobile = useBreakpoint('md');
    const isSmallDesktop = useBreakpoint('xl');
    const showOnlyIcon = !isMobile && isSmallDesktop;

    const privateRoutes = [
        {
            path: `/${RoutePaths.Favorites}`,
            text: t`Favorites`,
            icon: <HeartFilled />,
        },
        {
            path: `/${RoutePaths.Downloads}`,
            text: t`Downloads`,
            icon: <DownloadCircleFilled />,
        },
        {
            path: `/${RoutePaths.UserCollections}`,
            text: t`My Collections`,
            icon: <FolderFilled />,
        },
    ];

    const getPrivateNavigation = (handleClick?: () => void) => {
        if (!isAuthenticated) {
            return null;
        }

        return privateRoutes.map(({ path, icon: Icon, text }) => (
            <Nav.Link
                key={text}
                as={RouterLink}
                to={path}
                icon={!showOnlyIcon && Icon}
                onClick={handleClick}
                isCurrent={getIsCurrentPath(path, basename)}
            >
                <HiddenByCss isHidden={showOnlyIcon}>{text}</HiddenByCss>
                {showOnlyIcon && (
                    <Tooltip label={text} position="top" hasArrow>
                        {Icon}
                    </Tooltip>
                )}
            </Nav.Link>
        ));
    };

    return getPrivateNavigation;
};
